export default [
    {
        path: '/projects',
        name: 'projects',
        component: () => import(/* webpackChunkName: "Projects" */ '@/views/projects/Index.vue'),
        meta: {
            title: 'Projecten',
            requiresAuth: true,
        }
    },
    {
        path: '/projects/create',
        name: 'addProject',
        component: () => import(/* webpackChunkName: "ProjectsCreate" */ '@/views/projects/Create.vue'),
        meta: {
            title: 'Project toevoegen',
            requiresAuth: true,
        }
    },
    {
        path: '/projects/view/:id',
        name: 'viewProject',
        component: () => import(/* webpackChunkName: "ProjectsView" */ '@/views/projects/Show.vue'),
        meta: {
            title: 'Project bekijken',
            requiresAuth: true,
        }
    },
    {
        path: '/projects/edit/:id',
        name: 'editProject',
        component: () => import(/* webpackChunkName: "ProjectsEdit" */ '@/views/projects/Edit.vue'),
        meta: {
            title: 'Project bewerken',
            requiresAuth: true,
        }
    },
    {
        path: '/projects/dossier/:id',
        name: 'onlineProjectDossier',
        component: () => import(/* webpackChunkName: "onlineProjectDossier" */ '@/views/online-project-dossier/Index.vue'),
        meta: {
            title: 'Online Project Dossier',
            requiresAuth: true,
            onlineProjectDossier: true,
        }
    },
    {
        path: '/projects/dossier/:id/opdrachtgever',
        name: 'onlineProjectDossierCustomer',
        component: () => import(/* webpackChunkName: "onlineProjectDossierCustomer" */ '@/views/online-project-dossier/Customer.vue'),
        meta: {
            title: 'Opdrachtgever | Online Project Dossier',
            requiresAuth: true,
            onlineProjectDossier: true,
        },
    },
    {
        path: '/projects/dossier/:id/bedrijfsgegevens',
        name: 'onlineProjectDossierCompany',
        component: () => import(/* webpackChunkName: "onlineProjectDossierCompany" */ '@/views/online-project-dossier/Company.vue'),
        meta: {
            title: 'Bedrijfsgegevens | Online Project Dossier',
            requiresAuth: true,
            onlineProjectDossier: true,
        },
    },
    {
        path: '/projects/dossier/:id/object/:token',
        name: 'onlineProjectDossierObject',
        component: () => import(/* webpackChunkName: "onlineProjectDossierObject" */ '@/views/online-project-dossier/Object.vue'),
        meta: {
            title: 'Bedrijfsgegevens | Online Project Dossier',
            requiresAuth: true,
            onlineProjectDossier: true,
        },
    },
];